import { ClipboardList, Layers3, Paperclip, Route, Users } from "lucide-react";

export const packSectionLinks = [
  { href: "#possessions", label: "Possessions", icon: Layers3 },
  { href: "#users", label: "People", icon: Users },
  { href: "#lines", label: "Lines", icon: Route },
  { href: "#forms", label: "Forms", icon: ClipboardList },
  { href: "#uploads", label: "Attachments", icon: Paperclip },
];

export const packSectionIcon = (anchorId) => (
  packSectionLinks.find(({ href }) => href === `#${anchorId}`)?.icon
);
